import { roleTranslates, roleTranslatesBadge, roleBadges } from '@/config/roles'

export default {
  methods: {
    $_userMixin_getBadge(role) {
      return roleBadges[role]
    },
    $_userMixin_roleTranslate(role) {
      return roleTranslates[role]
    },
    $_userMixin_roleTranslateBadge(role) {
      return roleTranslatesBadge[role]
    },
    $_userMixin_getName(secondName, firstName) {
      return `${secondName} ${firstName}`.trim()
    },
    $_userMixin_getAvatar(avatar) {
      return avatar ? `/api/files/${avatar.physicalName}` : '/images/account/default.jpg'
    }
  }
}
